module.exports = __webpack_public_path__ + "static/media/invoice.5a81d98f.png";